// extracted by mini-css-extract-plugin
export default {"hoverActions":"HoverActions_hoverActions__oTg52","actionBtn":"HoverActions_actionBtn__cxivn","deleteBtn":"HoverActions_deleteBtn__7Atyk"};